<template>
    <div class="row h-100 align-items-center">
        <div class="mx-auto text-center col-xs-12 col-sm-6">
            <Alerta
                :variant="'danger'"
                :texto="`<h5>Desculpe, não foi possível encontrar o atendimento.</h5><h6>Por favor, entre em contato com a assistência.</h6>`"
                :icone="`<span class='material-symbols-outlined'>warning</span>`"
            />
        </div>
    </div>
</template>

<script setup>
import Alerta from "@/components/Alertas/Alerta.vue";
</script>